// Import alpine script //unpkg.com/alpinejs and create script tag and load async the alpine library
if (!window.Alpine) {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/alpinejs@3.15.0/dist/cdn.min.js';
    script.defer = true;
    document.head.appendChild(script);
}

document.addEventListener('alpine:init', () => {
    Alpine.data('collapse', (initialOpen = false) => ({
        open: initialOpen,
        blockQuestionToggle() {
            this.open = !this.open;
        }
    }));
});
